import { CrudConfig } from 'src/model/table';
import { useStores } from 'src/components/store';
import { Domain } from 'src/dtos/version.dto';
import domainService from 'src/services/domain.service';
import { SystemConfiguration } from '@src/utils/system-configuration';
import { ActionType } from '@src/utils/enums';

export const useDomainsCrudConfig = (): CrudConfig<Domain> => {
    const { fwVersionStore } = useStores();
    const maxDomainsCount = SystemConfiguration.getInstance().maxDomainsCount;
    const limitPerAction = SystemConfiguration.getInstance().maxDomainsCount / 2;
    const existingDomains = fwVersionStore.getDomains;

    const limitPerActionAlert = (domain: any) => {
        if (domain.domainAction === ActionType.BLOCK) {
            if (existingDomains.filter(d => d.domainAction === ActionType.BLOCK).length >= limitPerAction) {
                return `You've reached the max limit of ${limitPerAction} blocked domains`;
            }
        } else if (existingDomains.filter(d => d.domainAction === ActionType.ALLOW).length >= limitPerAction) {
            return `You've reached the max limit of ${limitPerAction} allowed domains`;
        }
        return undefined;
    };

    return {
        createNewText: 'Add',
        displayInlineActions: fwVersionStore.isSelectedVersionEditable,
        disableEditReason: fwVersionStore.getDisableReason,
        rowLimit: maxDomainsCount,
        entityName: 'domain',
        newRecord: {
            name: '',
            domainUrl: '',
            description: '',
            domainAction: existingDomains.filter(d => d.domainAction === ActionType.ALLOW).length >= limitPerAction ? ActionType.BLOCK : ActionType.ALLOW
        },
        saveCb: async (data: any) => {
            await fwVersionStore.genericCrudMethod(domainService.createDomain, [data]);
        },
        updateCb: async (updatedRecord: Domain, originalRecord: Domain) => {
            await fwVersionStore.genericCrudMethod(domainService.updateDomain, [updatedRecord, originalRecord.name, originalRecord.domainAction]);
        },
        removeCb: async (data) => {
            await fwVersionStore.genericCrudMethod(domainService.deleteDomain, [data.name, data.domainAction]);
        },
        dataChangesHandler: {},
        getDisableSaveAlert: limitPerActionAlert
    };
};